import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {RemotePutCreateRequestPreview} from 'data/usecases/private/refund/request-preview/remote-put-create-request-preview';
import {PutCreateRequestPreview} from 'domain/usecases/private/refund/request-preview/put-create-request-preview';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makePutCreateRequestPreview = (): PutCreateRequestPreview =>
	new RemotePutCreateRequestPreview(
		makeBFFApiUrl(RefundFlowEndPoints.requestPreview),
		makeAuthorizeHttpClientDecorator(),
	);
